import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconMegaphoneOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], c = ["clip-path"], m = ["id"];
function h(e, t, r, _, g, i) {
  return d(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--megaphone-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Megaphone Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.646.646a.5.5 0 0 1 .708 0L4.977 4.27a.512.512 0 0 1 .013.013l3.928 3.928a.508.508 0 0 1 .01.01l2.426 2.425a.5.5 0 0 1-.708.708L8.32 9.027l-2.048-.455a2.004 2.004 0 0 1-3.903-.867l-.976-.217A.5.5 0 0 1 1 7V5.5a.5.5 0 0 1 .366-.482l2.305-.64L.646 1.354a.5.5 0 0 1 0-.708ZM4.483 5.19 2 5.88v.719l5.003 1.11-2.52-2.52ZM3.349 7.923a1.005 1.005 0 0 0 1.94.43l-1.94-.43Zm7.454-5.321A.5.5 0 0 1 11 3v4.67a.5.5 0 0 1-1 0V3.658l-3.021.839a.5.5 0 0 1-.268-.964l3.655-1.015a.5.5 0 0 1 .437.084Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, c),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, p);
}
const M = /* @__PURE__ */ u(f, [["render", h]]);
export {
  M as default
};
//# sourceMappingURL=megaphone-off.js.map
